import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FloatingCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('precio');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <AnimatePresence data-id="element-98">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: '-50%'
    }} animate={{
      opacity: 1,
      y: 0,
      x: '-50%'
    }} exit={{
      opacity: 0,
      y: 50,
      x: '-50%'
    }} className="fixed bottom-6 left-1/2 z-[999] md:hidden" data-id="element-99">
          <a href="https://www.viventispace.com/cart/46018757623996:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="bg-gradient-to-br from-orange to-[#FF8C00] text-white px-7 py-3.5 rounded-full font-extrabold text-[14px] no-underline shadow-[0_8px_32px_rgba(255,107,0,0.5)] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(255,107,0,0.7)] whitespace-nowrap block" data-id="element-100">
            🏭 Obtener por $9.99 →
          </a>
        </motion.div>}
    </AnimatePresence>;
}